let get_jobsDash = function() {
	this.metodos(this.get_jobsDash)
};
export default get_jobsDash;
